import {Stack} from 'aws-cdk-lib'
import {IBucket, Bucket, BucketProps} from 'aws-cdk-lib/aws-s3'
import {BucketDeploymentProps, BucketDeployment, Source} from 'aws-cdk-lib/aws-s3-deployment'
import {Optional} from '@othree.io/optional'

export type BucketInput = Readonly<{
    name: string
}>

export type BucketDeploymentInput = Readonly<{
    name: string
    assetsPath: string
    bucket: IBucket
}>

/** Creates an S3 bucket. The bucket name is lowercased automatically. */
export const withBucket = (deps: {
    stack: Stack
}) =>
    (input: BucketInput, configuration?: Partial<BucketProps>): IBucket => {
        return new Bucket(deps.stack, input.name, {
            bucketName: input.name.toLowerCase(),
            ...Optional(configuration).orElse({})
        })
    }

/** Deploys local filesystem assets to an S3 bucket. */
export const withLocalAssetsBucketDeployment = (deps: {
    stack: Stack
}) =>
    (input: BucketDeploymentInput, configuration?: Partial<BucketDeploymentProps>): BucketDeployment => {
        return new BucketDeployment(deps.stack, input.name, {
            sources: [Source.asset(input.assetsPath)],
            destinationBucket: input.bucket,
            ...Optional(configuration).orElse({})
        })
    }

